<template>
  <md-content class="content">
    <h4>Devices</h4>

    <span v-if="devices.length === 0">No connected devices</span>
    <div
      v-for="device in devices"
      :key="device.device_id"
      class="container"
    >
      <div class="row">
        <static-info-field
          label="Platform"
          :value="device.platform"
        />

        <static-info-field
          label="Device ID"
          :value="device.device_id"
        />

        <md-button
          class="dangerButton"
          @click="onUnlinkDeviceClick(device.device_id)"
        >
          Unlink
        </md-button>
      </div>

      <div class="row">
        <static-info-field
          label="Name"
          :value="device.name"
        />

        <static-info-field
          label="Model"
          :value="device.model"
        />
      </div>

      <static-info-field
        v-if="device.notification_token"
        label="Notification token"
        :value="device.notification_token"
      />
    </div>
  </md-content>
</template>
<script>
import StaticInfoField from "./StaticInfoField";

export default {
  name: "UserDevicesSection",
  components: {
    StaticInfoField
  },
  props: {
    devices: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    onUnlinkDeviceClick (deviceId) {
      this.$emit("deviceUnlink", deviceId);
    }
  }
};
</script>
<style></style>
